module.exports = "images/vector.ebc0f44e.png";